import {useRoutes} from 'react-router-dom';
import {Helmet} from 'react-helmet-async';
import {Provider as ReduxProvider} from 'react-redux';
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {RTL} from './components/rtl';
import {SplashScreen} from './components/splash-screen';
import {Toaster} from './components/toaster';
import {SettingsConsumer, SettingsProvider} from './contexts/settings-context';
import {AuthConsumer, AuthProvider} from './contexts/auth/appAuth-context';
import {useNprogress} from './hooks/use-nprogress';
import {routes} from './routes';
import {store} from './store';
import {createTheme} from './theme';
// Remove if react-quill is not used
import 'react-quill/dist/quill.snow.css';
// Remove if react-draft-wysiwyg is not used
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// Remove if simplebar is not used
import 'simplebar-react/dist/simplebar.min.css';
// Remove if mapbox is not used
import 'mapbox-gl/dist/mapbox-gl.css';
// Remove if locales are not used
import './locales/i18n';
import {CountdownProvider} from "./contexts/countdown-context";
import {useEffect, useState} from "react";
// import Countdown from "./components/countDown";
import {onMessageListener, requestForToken} from "src/libs/firebase";
import BaseAlert from "./components/baseAlert";
import Countdown from "./components/countDown";
import ControllerCountdown from "./components/controllerCountdown";
import {ChatProvider} from "./contexts/chat-context";
import {useAuth} from "./hooks/auth/use-auth";
import {useIdleTimeout} from "./hooks/use-idleTimeout";

const IdleTimeoutHandler = ({ timeout }) => {
    useIdleTimeout(timeout);
    return null;
}

export const App = () => {
    useNprogress();
    let user = useAuth()
    const element = useRoutes(routes);
    const [notification, setNotification] = useState({type: 'info', title: '', message: ''});

    const [messageId, setMessageId] = useState('');
    const [notifyCaseID, setNotifyCaseID] = useState('');
    const audio = new Audio('alert-sound.mp3');

    onMessageListener()
        .then(async (payload,) => {
            if (payload) {
                let notifyNowCaseID = (payload && payload?.data?.[`caseID`]) ?? null;
                await setNotifyCaseID(notifyNowCaseID)
                await setNotification({
                    title: payload?.notification?.title,
                    body: payload?.notification?.body,
                    notifyName: payload?.data?.[`gcm.notification.name`],
                    caseID: notifyNowCaseID,
                    dispatch:payload?.data?.dispatch??null,
                    messageId: payload.messageId
                });
                await setMessageId(() => payload.messageId)
                await console.log("messageId", messageId)
                await BaseAlert('info', payload?.notification?.title, payload?.notification?.body)
            }
        })
        .catch((err) => console.log('failed: ', err))

    useEffect(() => {
        const fetchFCMToken = async () => {
            const token = await requestForToken();
            if (!token) {
                await BaseAlert('info', 'Warning! We are unable to access "Notification permission" in your browser.', 'As a result, the system will be unable to send notifications to you.');
            }
        };
        fetchFCMToken();
    }, []);


    const clearNotifyState =()=>{
        setNotification({type: 'info', title: '', message: ''})
        setMessageId('')
        setNotifyCaseID('')
    }
    return (
        <ReduxProvider store={store}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <AuthProvider>
                    <AuthConsumer>
                        {(auth) => (
                            <SettingsProvider>
                                <SettingsConsumer>
                                    {(settings) => {
                                        // Prevent theme flicker when restoring custom settings from browser storage
                                        if (!settings.isInitialized) {
                                            // return null;
                                        }

                                        const theme = createTheme({
                                            colorPreset: settings.colorPreset,
                                            contrast: settings.contrast,
                                            direction: settings.direction,
                                            paletteMode: settings.paletteMode,
                                            responsiveFontSizes: settings.responsiveFontSizes
                                        });

                                        // Prevent guards from redirecting
                                        const showSlashScreen = !auth.isInitialized;
                                        const sessionTimeout = auth.getSessionTimeout();

                                        return (
                                            <ThemeProvider theme={theme}>
                                                {auth.isAuthenticated && <IdleTimeoutHandler timeout={sessionTimeout} />}
                                                <Helmet>
                                                    <meta
                                                        name="color-scheme"
                                                        content={settings.paletteMode}
                                                    />
                                                    <meta
                                                        name="theme-color"
                                                        content={theme.palette.neutral[900]}
                                                    />
                                                </Helmet>
                                                <RTL direction={settings.direction}>
                                                    <CssBaseline/>
                                                    {showSlashScreen
                                                        ? <SplashScreen/>
                                                        : (
                                                            <>
                                                                <CountdownProvider>
                                                                    {/*<ChatProvider>*/}
                                                                        {/*<Chat/>*/}
                                                                        <ControllerCountdown notifyCaseID={notifyCaseID}
                                                                                             notification={notification}
                                                                                             clearNotifyState={clearNotifyState}
                                                                        />
                                                                        <Countdown/>
                                                                        {element}
                                                                        {/*</ChatProvider>*/}
                                                                </CountdownProvider>

                                                            </>
                                                        )}
                                                    <Toaster/>
                                                </RTL>
                                            </ThemeProvider>
                                        );
                                    }}
                                </SettingsConsumer>
                            </SettingsProvider>
                        )}
                    </AuthConsumer>
                </AuthProvider>
            </LocalizationProvider>
        </ReduxProvider>
    );
};
